<template>
  <transition name="modal">
    <div id="ajoutRequete" class="modal-wrapper">
      <b-card class="modal-container">
        <h2 class="mt-3 mb-3">Ajouter une Requête</h2>
        <div>
          <b-card class=" formAjout mr-4 ml-4">
              <form @submit.prevent="emitInsertRequete" id="validAdd">

              <b-form-group class="labelTitre" id="input-group-1" label="Titre*:" label-for="input-1">
                <Field name="titre" type="text" placeholder="renseigner le titre de la requête" class="form-control" />
                <ErrorMessage name="titre" class="text-danger" />
              </b-form-group>

              <b-form-group class="labelTitre" id="input-group-2" label="Description:" label-for="textarea-large">
                <Field name="description" as="textarea"  class="form-control" />
                <ErrorMessage name="description" class="text-danger" />
              </b-form-group>

            <b-row>
              <b-col md="6">
                <b-form-group class = "labelTitre" id="input-group-3" label="Schéma:" label-for="input-3">
                  <b-form-select id="input-3" v-model="schema.idSchema" >
                    <option v-for="s in schemas" v-bind:value="s.idSchema" v-bind:key="s.idSchema">{{s.nom}}</option>
                  </b-form-select>
                </b-form-group>
              </b-col>
              <b-col md="6">
                <b-form-group class = "labelTitre" id="input-group-4" label="Type:" label-for="input-4">
                  <b-form-select id="input-4" v-model="type" :options="optionType" ></b-form-select>
                </b-form-group>
              </b-col>
            </b-row>


              <b-form-group class="labelTitre" id="input-group-5" label="Définition sql (vos paramètres doivent être précédés et suivis des caractères '!!')"
              label-for="textarea-large">
                <Field name="sql" as="textarea" class="form-control" />
                <ErrorMessage name="sql" class="text-danger" />
              </b-form-group>

            <b-form-group class="labelTitre" id="input-group-7" label="Champ(s) anomalique(s)" label-for="input-7">
              <b-form-input id="input-7"  v-model="champAnomalique" type="text"></b-form-input>
            </b-form-group>

            <b-form-group class="labelTitre" id="input-group-8" label="Mots clés" label-for="input-8">
              <b-form-input id="input-8" v-model="keywords" type="text"></b-form-input>
            </b-form-group>

            <div class="separation mb-4 mt-4"></div>
            <div class="rapport mb-4">INFORMATIONS AFFICHEES SUR LE RAPPORT</div>

            <b-row>
              <b-col md="6">
                <b-form-group class = "labelTitre" id="input-group-9" label="Niveau de gravité" label-for="input-9">
                  <b-form-select id="input-9" v-model="gravite" :options="optionGravite"></b-form-select>
                </b-form-group>
              </b-col>
            </b-row>

            <b-form-group class="labelTitre" id="input-group-10" label="Message d'erreur" label-for="input-10">
              <b-form-input id="input-10" v-model="message" type="text"></b-form-input>
            </b-form-group>

            <b-form-group class="labelTitre" id="input-group-11" label="Tables" label-for="input-11">
              <b-form-input id="input-11" v-model="tables" type="text" ></b-form-input>
            </b-form-group>
                <b-button pill type="submit" class="nav-link3 m-2">Valider</b-button>
                <b-button id="close" pill class="nav-link2 m-2" @click="$emit('close')">Annuler</b-button>
              </form>
          </b-card>
        </div>
      </b-card>
    </div>         
  </transition>    
</template>

<script>
import { Field, ErrorMessage} from 'vee-validate';
import useAjoutRequete from "@/composition/Requetes/addRequete";

export default {
name:"ModalAddRequete",

  components:{
    Field,
    ErrorMessage,
  },

  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  setup(_, { emit }){
    return useAjoutRequete({emit});
  }
}



</script>

<style>

.labelTitre{
  text-align: left !important;
  padding-top: 10px;
}
.formAjout{
  background-color: #c0c0c0;
}

.separation{
  border-block-end-style: solid !important;
}
.rapport{
  text-align: left !important;
}

.modal-wrapper {
  vertical-align: middle;
}

.modal-container {
  width: 80%;
  margin: 0px auto;
  padding: 5px 10px;
  border-radius: 10px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
  transition: all 0.3s ease;
  font-family: Helvetica, Arial, sans-serif;
  background-color: white;
}

.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}

</style>